import { gql } from '@efficiently/client-core-graphql-models';

export const CREATE_FINISHES = gql(`
	mutation ProjectLocationCreateFinishes($projectId: String!, $finishes: [FinishInput!]!) {
		createFinishes(projectId: $projectId, finishes: $finishes) {
			...FinishDomainFinishFields
		}
	}
`);

// TODO(EFF-21352): (createdFinishIds) replace inline copy with FINISH_ID_FIELDS from data-access-finish-id
export const CREATE_FINISHES_WITH_CASCADE = gql(`
	mutation CreateFinishesCascade($projectId: String!, $finishes: [FinishInput!]!, $designChangeCapture: DesignChangeCaptureInput) {
		createFinishesCascade(projectId: $projectId, finishes: $finishes, designChangeCapture: $designChangeCapture) {
			finishes {
				...FinishDomainFinishFields
			}
			cascade {
				finishIds {
					_id
					status
				}
				finishes {
					_id
					status
				}
			}
			createdFinishIds {
				_id
				createdDate
				createdById
				lastModifiedDate
				lastModifiedById
				orgId
				projectId
				category
				color
				croppedImage
				division
				image
				index
				isDeleted
				itemId
				itemIdType
				itemNotes
				installationNotes
				keyLabel
				label
				lastItemUpdateDate
				procurementNotes
				procurementType
				remarks
				sortOrder
				status
				subtype
				type
				unitOfMeasure
				wastage
				rate
			}
		}
	}
`);
